import React from 'react'
import { connect } from 'react-redux'
import UserAvatarWithStats from 'app/components/UserAvatarWithStats/UserAvatarWithStats'
import { getUserInitials, getUserFullName } from 'helpers/getUserUIData'
import { getFeedLeaderBoardSection } from 'store/entities/feed/selectors'
import { SECTION_STREAK } from 'app/constants/feed'

const mapStateToProps = state => ({
  isStreakSection: getFeedLeaderBoardSection(state) === SECTION_STREAK,
})

const FeedLeaderBoardItem = ({
  index,
  leaderBoardItem: { firstName, lastName, avatar, email, streakCurrent, proTrackProgress, completedCount },
  isStreakSection,
}) => {
  const numberForReport = isStreakSection ? streakCurrent || 0 : completedCount || 0
  const initials = getUserInitials(firstName, lastName, email)
  const fullName = getUserFullName(firstName, lastName)
  return (
    <li className="leader-board-item">
      <div className="leader-board-item__number">{index + 1}</div>
      <UserAvatarWithStats
        isLeaderBoard
        avatar={avatar}
        initials={initials}
        proTrackProgress={proTrackProgress}
        streakCurrent={streakCurrent}
        circleProps={{
          cx: 17,
          cy: 17,
          strokeWidth: 2,
          r: 16,
        }}
      />
      <div className="leader-board-item__full-name">{fullName}</div>
      <div className="leader-board-item__number-for-report">{numberForReport}</div>
    </li>
  )
}

FeedLeaderBoardItem.displayName = 'FeedLeaderBoardItem'

const FeedLeaderBoardItemContainer = connect(mapStateToProps)(FeedLeaderBoardItem)

FeedLeaderBoardItemContainer.displayName = 'FeedLeaderBoardItemContainer'

export default FeedLeaderBoardItemContainer
